'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveOfferModalContainer = exports.mapDispatchToProps = exports.mapStateToProps = exports.modalConfig = undefined;

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _saveOffer = require('./saveOffer.saga');

var _SaveOffer = require('./components/SaveOffer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalConfig = exports.modalConfig = {
  headerClass: 'modal__save-offer',
  lightClose: true
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var _ref = _bound.saveOffer.data(state) || {},
      credits = _ref.credits_per_cycle,
      currencyCode = _ref.currency_code,
      price = _ref.price,
      rolloverCredits = _ref.rollover_credits;

  var _ref2 = _bound.userProfile.data(state) || {},
      firstName = _ref2.first_name;

  return {
    credits: credits,
    currencyCode: currencyCode,
    loading: state.page.flags[_saveOffer.SUBSCRIPTION_CHANGE_REQUEST],
    name: firstName,
    price: price,
    rolloverCredits: rolloverCredits
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onAccept: _saveOffer.acceptSaveOffer,
  onModalClose: _saveOffer.closeSaveOffer
};

var SaveOfferModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _Modal2.default)(modalConfig)(_SaveOffer.SaveOffer));

exports.SaveOfferModalContainer = SaveOfferModalContainer;